import { chakra, VStack } from '@chakra-ui/react'
import { RequestsLayout } from '@src/components/sco/Requests/Layout/RequestsLayout'
import { RequestLPMyRequestsGrid } from '@src/components/sco/Requests/RequestsLP/RequestLPMyRequestsGrid'
import { SignupRequestBuilder } from '@src/components/sco/Requests/SignupRequestBuilder'
import { SSRGate } from '@src/components/sco/utilities/SSRGate'
import { Block } from '@src/pages/landing/first-10k'
import { useParams } from 'next/navigation'
import React from 'react'

export default function Page() {
  const params = useParams()

  return (
    <RequestsLayout
      groupRequestId={params.groupRequestId?.toString()}
      navPanelOpen={false}
      mainPanel={
        <VStack align={'center'} width={'full'}>
          <Block
            boxProps={{
              bgColor: 'colorPalette.panel',
              width: 'full',
            }}
            headingProps={{
              children: (
                <>
                  {'Tell us your goal. '}
                  <br />
                  <chakra.span
                    {...{
                      backgroundImage: 'linear-gradient(90deg, #d97258 0%, #9858a3 100%)',
                      backgroundClip: 'text',
                      color: 'transparent',
                    }}
                  >
                    We'll show you how to get there.
                  </chakra.span>
                </>
              ),
            }}
          >
            <SSRGate disableSSR={true}>
              <SignupRequestBuilder />
              <RequestLPMyRequestsGrid />
            </SSRGate>
          </Block>
        </VStack>
      }
    />
  )
}
